var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00B0F0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1c2.946-.098 5.801 1.03 7.886 3.114C21.97 6.2 23.098 9.054 23 12c.098 2.946-1.03 5.801-3.114 7.886C17.8 21.97 14.946 23.098 12 23c-2.946.098-5.801-1.03-7.886-3.114C2.03 17.8.902 14.946 1 12 .902 9.054 2.03 6.199 4.114 4.114 6.2 2.03 9.054.902 12 1zm.323 1.324L12 2.33c-2.591-.09-5.103.9-6.936 2.734C3.23 6.897 2.24 9.409 2.33 12c-.09 2.591.9 5.103 2.734 6.936C6.897 20.77 9.409 21.76 12 21.67c2.591.09 5.103-.9 6.936-2.734C20.77 17.103 21.76 14.591 21.67 12c.09-2.591-.9-5.103-2.734-6.936C17.103 3.23 14.591 2.24 12 2.33zm.337 5.556v3.46H16v1.33h-3.34v3.44h-1.32v-3.44H8v-1.33h3.34V7.88h1.32z",
    transform: "translate(-115 -740) translate(115 740)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.9c0794f984eebdc77d785c776fea13b0.svg";
export { ForwardRef as ReactComponent };